import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/Home/index"),
  },
  {
    path: "/technology/:slide_id?",
    name: "Technology",
    component: () => import("@/views/Technology/index"),
  },
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/About/index"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/User/Login/index"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/User/Register/index"),
  },
  {
    path: "/register/verify",
    name: "Verify",
    component: () => import("@/views/User/Register/Verify/index"),
  },
  {
    path: "/reset_password",
    name: "ResetPassword",
    component: () => import("@/views/User/ResetPassword/index"),
  },
  {
    path: "/memberportal",
    name: "MemberPortal",
    component: () => import("@/views/User/MemberPortal/index"),
  },
  {
    path: "/icselector",
    name: "IcSelector",
    component: () => import("@/views/IcSelector/index"),
  },
  {
    path: "/registerok",
    name: "RegisterOk",
    component: () => import("@/views/User/Register/Ok/index"),
  },
  {
    path: "/sendauth",
    name: "SendAuth",
    component: () => import("@/views/User/SendAuth/index"),
  },
  {
    path: "/touchsize",
    name: "TouchSize",
    component: () => import("@/views/TouchSize/index"),
  },
  {
    path: "/news",
    name: "News",
    component: () => import("@/views/News/index"),
  },
  {
    path: "/newsdetail",
    name: "NewsDetail",
    component: () => import("@/views/News/Detail/index"),
  },
  {
    path: "/application/:tab_id",
    name: "Application",
    component: () => import("@/views/Application/index"),
  },
  {
    path: "/producttype/:link_id/:type/:sub_tab_id/:need_slide",
    name: "ProductType",
    component: () => import("@/views/ProductType/index"),
  },
  {
    path: "/download/:type/:id",
    name: "Download",
    component: () => import("@/views/Download/index"),
  },
  {
    path: "/touchmanagerdownload",
    name: "TouchManagerDownload",
    component: () => import("@/views/Download/TouchManager/index"),
  },
  {
    path: "/company/:tab_id/:sub_tab_id",
    name: "InvestorRelation",
    component: () => import("@/views/InvestorRelation/index"),
  },
  {
    path: "/contactus",
    name: "ContactUs",
    component: () => import("@/views/ContactUs/index"),
  },
  {
    path: "/faq",
    name: "Faq",
    component: () => import("@/views/Faq/index"),
  },
  {
    path: "/faq/detail/:id",
    name: "FaqDetail",
    component: () => import("@/views/Faq/Detail/index"),
  },
  {
    path: "/supportcenter/:type?",
    name: "SupportCenter",
    component: () => import("@/views/SupportCenter/index"),
  },
  {
    path: "/accessory/:link_id/:tab_id",
    name: "Accessory",
    component: () => import("@/views/Accessory/index"),
  },
];

const createRouter = () =>
  new VueRouter({
    scrollBehavior: () => ({ y: 0 }),
    mode: "history",
    base: process.env.BASE_URL,
    routes,
  });

const router = createRouter();

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
